// extracted by mini-css-extract-plugin
export var closeButton = "_10-1";
export var container = "_10-0";
export var fullModalImage = "_10-2";